module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"foot-note":"Se você está prestes a cadastrar o rosto de uma criança, você confirma ser seu pai, mãe ou o responsável legal. Se não for, você confirma que tem autorização de responsável legal para fazê-lo.","privacy-policy":"Política de Privacidade"}}')
  delete Component.options._Ctor
}
